export default __webpack_public_path__ + "static/Onevillagesdramatictransformation-f10be4406294ba0cfc61d4b70324f8c5.jpg";